import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import { mainnet, base, arbitrum, optimism, polygon } from 'wagmi/chains';

export const config = getDefaultConfig({
  appName: 'LazaiTrader',
  projectId: import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || 'demo-project-id',
  chains: [mainnet, base, arbitrum, optimism, polygon],
  ssr: false,
});

export const supportedChains = [mainnet, base, arbitrum, optimism, polygon];
